import React from 'react';
import { Home, Users, Grid3X3, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const MobileFooter = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const navItems = [
    {
      icon: Home,
      label: 'Home',
      path: '/home',
      active: isActive('/home')
    },
    {
      icon: Users,
      label: 'Members',
      path: '/members',
      active: isActive('/members')
    },
    {
      icon: Grid3X3,
      label: 'Category',
      path: '/categories',
      active: isActive('/categories')
    },
    {
      icon: User,
      label: 'Profile',
      path: '/profile',
      active: isActive('/profile')
    }
  ];

  return (
    <>
      {/* Add bottom padding to prevent content hiding */}
      <div className="lg:hidden h-16"></div>

      {/* Solid, not translucent: the backdrop-blur that made 80% opacity read
          cleanly is gone, so content scrolling underneath showed through.
          safe-bottom pads for the iOS home indicator in standalone mode. */}
      <footer className="lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-line/15 bg-surface safe-bottom">
        <div className="flex items-center justify-around px-2 py-2">
          {navItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={index}
                to={item.path}
                className={`flex flex-col items-center justify-center rounded-lg px-3 py-2 transition-all duration-200 ${
                  item.active
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted hover:bg-surface2 hover:text-primary'
                }`}
              >
                <IconComponent
                  size={20}
                  className={item.active ? 'text-primary' : 'text-muted'}
                />
                <span
                  className={`mt-1 font-display text-xs font-medium ${
                    item.active ? 'text-primary' : 'text-muted'
                  }`}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </footer>
    </>
  );
};

export default MobileFooter;